import React, { useEffect, useState } from 'react';
import { Popup, Toast } from 'antd-mobile';
import axios from 'axios';
import API_ROUTES from '../../../api';
import Icon from '../../../icon';

const SUBSTITUTE_ACTIONS = [
    { value: 0, label: '受伤', icon: Icon.SHOUSHANG, tone: 'injury', description: '记录该替补球员受伤' },
    { value: 5, label: '黄牌', icon: Icon.YELLOW_CARD, tone: 'yellow', description: '为该替补球员记录黄牌' },
    { value: 6, label: '红牌', icon: Icon.RED_CARD, tone: 'red', description: '为该替补球员记录红牌' },
];

// 替补球员的信息记录使用单层底部面板，选择事件后一次确认提交。
const SubstitutePlayerActionPopup = ({
    player,
    gameDetail,
    getMemberImage,
    onClose,
    onUpdated,
}) => {
    const visible = Boolean(player);
    const [action, setAction] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (!visible) return;
        setAction(null);
        setSubmitting(false);
    }, [visible, player?.id]);

    const selectedAction = SUBSTITUTE_ACTIONS.find(item => item.value === action);

    const submit = async () => {
        if (action === null) {
            Toast.show({ icon: 'fail', content: '请选择需要记录的事件' });
            return;
        }

        setSubmitting(true);
        try {
            const response = await axios.post(API_ROUTES.game_event, {
                gameId: gameDetail.id,
                memberId: player.id,
                eventId: action,
            }, {});
            if (response.data.code === 200) {
                Toast.show({ icon: 'success', content: '记录成功！' });
                onClose();
                onUpdated();
            } else {
                Toast.show({ icon: 'fail', content: response.data.msg });
            }
        } catch (error) {
            Toast.show({ icon: 'fail', content: '记录失败，请联系管理员！' });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Popup
            visible={visible}
            onMaskClick={onClose}
            bodyStyle={{ borderTopLeftRadius: 24, borderTopRightRadius: 24, maxHeight: '82vh', overflow: 'hidden' }}
            style={{ '--z-index': 1400 }}
        >
            <div className="pitch-action-sheet substitute-action-sheet">
                <div className="pitch-action-header">
                    <button type="button" className="pitch-action-cancel" onClick={onClose}>取消</button>
                    <div className="pitch-action-player">
                        {player && <img src={getMemberImage(player)} alt="" />}
                        <div>
                            <strong>{player?.name || '替补球员'}</strong>
                            <span>{player?.gameRoleName || '替补阵容'} · 信息记录</span>
                        </div>
                    </div>
                    <button type="button" className="pitch-action-confirm" disabled={submitting} onClick={submit}>
                        {submitting ? '提交中' : '确认'}
                    </button>
                </div>

                <div className="pitch-action-content">
                    <div className="pitch-action-section-title"><span>1</span>选择记录类型</div>
                    <div className="pitch-action-grid substitute-action-grid">
                        {SUBSTITUTE_ACTIONS.map(item => (
                            <button
                                key={item.value}
                                type="button"
                                className={`${item.tone}${action === item.value ? ' active' : ''}`}
                                onClick={() => setAction(current => current === item.value ? null : item.value)}
                            >
                                <img src={item.icon} alt="" />
                                <strong>{item.label}</strong>
                                {action === item.value && <em>✓</em>}
                            </button>
                        ))}
                    </div>

                    {selectedAction ? (
                        <div className={`pitch-action-simple-note ${selectedAction.tone}`}>
                            <img src={selectedAction.icon} alt="" />
                            <div>
                                <strong>{selectedAction.label}记录</strong>
                                <span>{selectedAction.description}，点击右上角确认提交。</span>
                            </div>
                        </div>
                    ) : (
                        <div className="substitute-action-help">请选择一项需要记录的替补球员状态</div>
                    )}

                    <div className="pitch-action-summary">
                        {selectedAction ? `${player?.name} · ${selectedAction.label}` : `${player?.name || '当前球员'} · 待选择记录类型`}
                    </div>
                </div>
            </div>
        </Popup>
    );
};

export default SubstitutePlayerActionPopup;
